import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { Leaf, ArrowLeft } from "lucide-react";
import AppShell from "@/components/AppShell";

export default function About() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const steps = t("about.howSteps", { returnObjects: true });
  const tips = t("about.tipsItems", { returnObjects: true });
  const organize = t("about.organizeItems", { returnObjects: true });
  const shareItems = t("about.shareItems", { returnObjects: true });
  const desktopItems = t("about.desktopItems", { returnObjects: true });
  return (
    <AppShell>
      <div className="md:max-w-2xl md:mx-auto">
      <div className="px-5 pt-1 flex items-center gap-3" data-testid="about-page">
        <button
          onClick={() => navigate(-1)}
          aria-label={t("common.back")}
          data-testid="about-back"
          className="w-9 h-9 rounded-full bg-white border border-[#E8E5DF] flex items-center justify-center text-leaf-ink"
        >
          <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
        </button>
        <h1 className="font-display text-3xl text-leaf-ink leading-tight">{t("about.title")}</h1>
      </div>

      <div className="px-5 mt-6 space-y-5 pb-2">
        <section className="bg-white rounded-3xl border border-[#E8E5DF] p-5" data-testid="about-what">
          <div className="flex items-center gap-2 text-leaf">
            <Leaf className="w-4 h-4" strokeWidth={1.5} />
            <h2 className="text-xs uppercase tracking-[0.18em] font-medium">{t("about.whatTitle")}</h2>
          </div>
          <p className="mt-3 text-leaf-ink leading-relaxed">{t("about.what")}</p>
        </section>

        <section
          className="rounded-3xl border border-leaf/20 p-5 bg-gradient-to-br from-leaf/[0.05] to-transparent"
          data-testid="about-why"
        >
          <h2 className="text-xs uppercase tracking-[0.18em] font-medium text-leaf">{t("about.whyTitle")}</h2>
          <p className="mt-3 text-leaf-ink leading-relaxed">{t("about.why")}</p>
        </section>

        <section className="bg-white rounded-3xl border border-[#E8E5DF] p-5">
          <h2 className="text-xs uppercase tracking-[0.18em] font-medium text-leaf">{t("about.howTitle")}</h2>
          <ol className="mt-3 list-decimal pl-5 space-y-2 text-leaf-ink leading-relaxed">
            {Array.isArray(steps) && steps.map((s) => <li key={s}>{s}</li>)}
          </ol>
        </section>

        <section className="bg-white rounded-3xl border border-[#E8E5DF] p-5" data-testid="about-organize">
          <h2 className="text-xs uppercase tracking-[0.18em] font-medium text-leaf">{t("about.organizeTitle")}</h2>
          <ul className="mt-3 list-disc pl-5 space-y-2 text-leaf-ink leading-relaxed">
            {Array.isArray(organize) && organize.map((s) => <li key={s}>{s}</li>)}
          </ul>
        </section>

        <section className="bg-white rounded-3xl border border-[#E8E5DF] p-5" data-testid="about-share">
          <h2 className="text-xs uppercase tracking-[0.18em] font-medium text-leaf">{t("about.shareTitle")}</h2>
          <ul className="mt-3 list-disc pl-5 space-y-2 text-leaf-ink leading-relaxed">
            {Array.isArray(shareItems) && shareItems.map((s) => <li key={s}>{s}</li>)}
          </ul>
        </section>

        <section className="bg-white rounded-3xl border border-[#E8E5DF] p-5" data-testid="about-desktop">
          <h2 className="text-xs uppercase tracking-[0.18em] font-medium text-leaf">{t("about.desktopTitle")}</h2>
          <ul className="mt-3 list-disc pl-5 space-y-2 text-leaf-ink leading-relaxed">
            {Array.isArray(desktopItems) && desktopItems.map((s) => <li key={s}>{s}</li>)}
          </ul>
        </section>

        <section className="bg-white rounded-3xl border border-[#E8E5DF] p-5">
          <h2 className="text-xs uppercase tracking-[0.18em] font-medium text-leaf">{t("about.tipsTitle")}</h2>
          <ul className="mt-3 list-disc pl-5 space-y-2 text-leaf-ink leading-relaxed">
            {Array.isArray(tips) && tips.map((s) => <li key={s}>{s}</li>)}
          </ul>
        </section>

        <section className="bg-white rounded-3xl border border-[#E8E5DF] p-5">
          <h2 className="text-xs uppercase tracking-[0.18em] font-medium text-leaf">{t("about.creditsTitle")}</h2>
          <p className="mt-3 text-leaf-ink leading-relaxed">{t("about.credits")}</p>
        </section>

        <div className="flex flex-wrap gap-3 text-sm">
          <Link to="/privacy" className="text-leaf underline" data-testid="about-privacy-link">{t("login.privacy")}</Link>
          <span className="text-leaf-mist">·</span>
          <Link to="/terms" className="text-leaf underline" data-testid="about-terms-link">{t("login.terms")}</Link>
        </div>
      </div>
      </div>
    </AppShell>
  );
}
